<!--
  TODO Do the class labeling on the power-chart side so we don't have to use bar-1, bar-2, etc.
-->
<div [class]="cssLabel">
  <svg name="chart" class="percent-bar-chart"></svg>
</div>
